import { ChangeEvent } from "react";
import { Grid } from "@mui/material";
import { CloudDownload } from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import { FormattedMessage, useIntl } from "react-intl";
import { addMonths, endOfMonth, startOfMonth, subMonths } from "date-fns";

import { Breadcrumbs, PageHeader } from "@dzambalaorg/mui-page-layout";
import { DateTimeInput } from "@dzambalaorg/mui-inputs-picker";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";
import { useFetchQuery } from "@dzambalaorg/react-hooks";
import { IAchievementItem } from "@framework/types";
import { IPaginationResult } from "@dzambalaorg/types-collection";
import { Button, FormGrid } from "@dzambalaorg/ui-kit";

import { achievementsColumnsCreator } from "./schemas";

const ACHIEVEMENTS_REPORT_URL = "/achievements/report";

export const AchievementReport = () => {
  const { isLoading, take, skip, onChangePage, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IAchievementItem>
  >(ACHIEVEMENTS_REPORT_URL, void 0, void 0, {
    account: "",
    startTimestamp: startOfMonth(subMonths(new Date(), 1)).toISOString(),
    endTimestamp: endOfMonth(addMonths(new Date(), 1)).toISOString(),
  });

  const { formatMessage } = useIntl();

  // TODO - [AFTER ALL REFACTORING] - check possibility to return search values from useFetchQuery
  // const { fn } = useApiCall(async (api, values) => {
  //   return api.fetchFile({
  //     url: "/ponzi/report/export",
  //     data: values,
  //   });
  // });

  const handleExport = (): Promise<void> => {
    // return fn(void 0, search);
    return Promise.resolve();
  };

  // prettier-ignore
  const columns = achievementsColumnsCreator(formatMessage);

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "achievements", "achievements.report"]} />

      <PageHeader message="pages.achievements.report.title">
        <Button startIcon={<CloudDownload />} onClick={handleExport}>
          <FormattedMessage id="form.buttons.export" />
        </Button>
      </PageHeader>

      <SearchWithFilters
        initialValues={{
          account: "",
          startTimestamp: startOfMonth(subMonths(new Date(), 1)).toISOString(),
          endTimestamp: endOfMonth(addMonths(new Date(), 1)).toISOString(),
        }}
        name="account"
      >
        <FormGrid columns={[2]}>
          <DateTimeInput
            slotProps={{
              popper: {
                sx: {
                  "& .MuiPickersTextField-root": {
                    margin: 0,
                  },
                },
              },
            }}
            name="startTimestamp"
            size="small"
          />
          <DateTimeInput
            slotProps={{
              popper: {
                sx: {
                  "& .MuiPickersTextField-root": {
                    margin: 0,
                  },
                },
              },
            }}
            name="endTimestamp"
            size="small"
          />
        </FormGrid>
      </SearchWithFilters>

      <DataGrid
        pagination
        paginationMode="server"
        rowCount={totalCount}
        paginationModel={{ page: skip / take, pageSize: take }}
        onPaginationModelChange={({ page }) => onChangePage({} as ChangeEvent<unknown>, page)}
        pageSizeOptions={[5, 10, 25]}
        loading={isLoading}
        columns={columns}
        rows={allRows.map((item: IAchievementItem) => ({
          id: item.id,
          account: item.user.wallet,
          title: item.achievementRule.title,
          createdAt: item.createdAt,
        }))}
      />
    </Grid>
  );
};
